import React from 'react';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import { Typography } from '@material-ui/core';
import { Children } from 'react';

//>>>>>>>>>> Icon 
import WorkIcon from '@material-ui/icons/Work';
// >>> css
import './Timeline.css'


//>>>>>>>>>> main component start 


const TimeLineCom = ({title,children,icon}) => {




    return (
        <div>
            <Timeline className={'timeline'} >
                {/* First Time Line  */}
                <TimelineItem className={'timeline_first'} >
                    <TimelineSeparator>
                    <TimelineDot className={'timeline_dot_header'} >
                        {icon}
                    </TimelineDot>
                    <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                        <Typography variant="h6" className={'timeline_header'}  >
                           {title} 
                        </Typography>
                    </TimelineContent>
                </TimelineItem>
                {/* second Time Line  */}
            {children}

               

    </Timeline>
        </div>
    );
};

export const CoustorTimelineSeparator = () => (
    <TimelineSeparator className={'separator_padding'}>
    <TimelineDot variant="outlined" className={'timeline_dot'} />
    <TimelineConnector />
    </TimelineSeparator>
)

export default TimeLineCom;